import axios from "axios";
import {
	METHOD_TYPE,
	GRAPHQL_ENDPOINT,
	ATTRIBUTE_TYPE,
	RECOGNITION_TYPES_ENUM
} from "@/common/utils/constants";

const URL = process.env.VUE_APP_BACKEND_API_URL;
let endpoint = `${URL}/gop/main`;

export function getRecognitionById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchPaginatedRecognitions(
						criteria: {
								sort: { by: "lastUpdateDate", order: "DESC" }
								pageable: { page: 0, size: 1000 }
								ids: [${id}]
						}
				) {
						totalElements
						totalPages
						size
						number
						content {
								id
								isActive
								isPublished
								url
								file {
										url
										key
										id
								}
								translations {
										languageId
										title
										id
										insights
										description
								}
								images {
										type
										url
										id
										key
								}
								userFavorites {
										userId
										id
								}
								views
								offers {
										id
										type
										isActive
										isPublished
								}
								sectors {
										id
										category
										isActive
										isPublished
								}
								editors {
										id
										fullName
										email
								}
								creatorId
								lastUpdateDate
								regions
								submission {
										id
										languageId
										creationDateTime
										publishedDateTime
								}
								industryRelations {
										id
										industryId
										subIndustryRelations {
												id
												subIndustryId
										}
								}
								serviceLineRelations {
										id
										serviceLineId
										subServiceLineRelations {
												id
												subServiceLineId
										}
								}
								techPracticeRelations {
										id
										techPracticeId
										subTechPracticeRelations {
												id
												subTechPracticeId
										}
								}
								qualificationAttributeRelations {
										id
										qualificationAttributeId
								}
								additionalLinks {
										id
										name
										url
								}
								globalOwners {
										id
										fullName
										email
								}
								mainGlobalOwner {
										id
										globalOwner {
												id
												fullName
												email
										}
								}
								additionalResources {
										id
										name
										url
										awsKey
								}
								analysts {
										id
										name
								}
						}
				}
			}
		`
		}
	}).then(res => {
		return res.data.data.searchPaginatedRecognitions?.content;
	})
}

export function initializeForm(creatorId, languageId = 1) {
	return axios.post(`${endpoint}/recognitions/initialize`, {creatorId, languageId}).then(response => {
		return response.data;
	})
}

export function getFormData(RecognitionId) {
	return axios.get(`${endpoint}/recognitions/${RecognitionId}/submission-form`).then(response => {
		return response.data;
	})
}

export function cloneGlobalRecognitionFiles(localizedRecognitionId, globalRecognitionId) {
	return axios.post(`${endpoint}/recognitions/${globalRecognitionId}/clone-to/${localizedRecognitionId}`).then(response => {
		return response.data;
	})
}

export function getTranslatedRecognition(creatorId, RecognitionId, fromLanguage, toLanguageId){
	const data = {
		"initializer": {
			"languageId": toLanguageId,
			"creatorId": creatorId
		},
		"fromLanguage": fromLanguage,
		"fromRecognitionId": RecognitionId
	}

	return axios.post(`${endpoint}/recognitions/translations/submission-form`, data).then(response => {
		return response.data;
	});
}

export const countriesEnums = {
	DELIVERY_LOCATION: "DELIVERY_LOCATION",
	FASTEST_GROWING_MARKETS: "FASTEST_GROWING_MARKET",//note the missing S
	LARGEST_MARKETS: "LARGEST_MARKET",//note the missing S
}

export function formatNewQualificationAttributes(form) {
	const arr = [];
	form.toolsAndSystems.forEach((tool) => {
		if (!tool.id) {
			arr.push({name: tool.name, type: ATTRIBUTE_TYPE.tool})
		}
	});

	form.certifications.forEach((certification) => {
		if (!certification.id) {
			arr.push({name: certification.name, type: ATTRIBUTE_TYPE.certification})
		}
	})

	return arr;
}

export function fillFormDataWithRecognition(Recognition, form, validationService) {
	form.id = Recognition.id;
	form.url = Recognition.url;

	form.file = null;
	form.fileUrl = null;
	form.awsKey = null;

	if (Recognition.file) {
		form.file = Recognition.file.url;
		form.fileUrl = Recognition.file.url;
		form.awsKey = Recognition.file.key;
	}

	// if (Recognition.awsKey){
	// 	form.file = Recognition.url;
	// 	form.fileUrl = Recognition.url;
	// 	form.awsKey = Recognition.awsKey;
	// }
	form.logo = null;
	form.logoUrl = null;
	form.logoAwsKey = null;

	if (Recognition.images) {
		const logo = Recognition.images.find(i => i.type === 'LOGO');
		if (logo) {
			form.logo = logo.url;
			form.logoUrl = logo.url;
			form.logoAwsKey = logo.key;
		}
	}

	// form.logo = Recognition.logoUrl;
	// form.logoUrl = Recognition.logoUrl;
	// form.logoAwsKey = Recognition.logoAwsKey;

	form.title = null;
	if (Recognition.translations && Recognition.translations[0]) {
		form.title = Recognition.translations[0].title;
	}

	// const languageIndex = Recognition.translations.findIndex(el => el.languageId === Recognition.submission.languageId) || 0;
	//
	// form.videoLink = Recognition.videoUrl;
	//
	// form.language = [LANGUAGE_ARRAY.find(el => el.id === Recognition.translations[languageIndex].languageId)];
	//
	// form.title = Recognition.translations[languageIndex].title || '';
	// form.description = Recognition.translations[languageIndex].description || '';
	// form.biggestMarketConclusion = Recognition.translations[languageIndex].biggestMarketConclusion || '';
	// form.keyMarketDrivers = Recognition.translations[languageIndex].keyMarketDrivers || '';
	// form.marketOpportunities = Recognition.translations[languageIndex].marketOpportunities || '';
	// form.keyHighlights = Recognition.translations[languageIndex].keyHighlights || '';
	// form.additionalNotes = Recognition.translations[languageIndex].additionalNotes || '';
	// form.clientNeeds = Recognition.translations[languageIndex].clientNeeds || '';
	// form.clientBenefits = Recognition.translations[languageIndex].clientBenefits || '';
	// form.tips = Recognition.translations[languageIndex].tips || '';
	// form.competitors = Recognition.competitors;
	// form.largestMarket = [];
	// form.fastestGrowingMarket = [];
	// form.deliveryLocation = [];
	// Recognition.countries.forEach((country) => {
	// 	let currCountry = validationService.countries.find(el => el.id === country.id);
	// 	if (country.type === countriesEnums.LARGEST_MARKETS) {
	// 		form.largestMarket.push({id: country.id, name: currCountry.name})
	// 	} else if (country.type === countriesEnums.FASTEST_GROWING_MARKETS) {
	// 		form.fastestGrowingMarket.push({id: country.id, name: currCountry.name})
	// 	} else if (country.type === countriesEnums.DELIVERY_LOCATION) {
	// 		form.deliveryLocation.push({id: country.id, name: currCountry.name})
	// 	}
	// });
	//
	// form.projectIndustry = [];
	// Recognition.industries.forEach((industry) => {
	// 	const currIndustry = validationService.industries.find(el => el.id === industry.id);
	// 	if (industry.subIndustries.length === 0) {
	// 		form.projectIndustry.push({id: "_" + currIndustry.id, name: currIndustry.name});
	// 	} else {
	// 		industry.subIndustries.forEach((subIndustry) => {
	// 			const currSubIndustry = currIndustry.subIndustries.find(el => el.id === subIndustry.id);
	// 			form.projectIndustry.push({id: currSubIndustry.id, name: currSubIndustry.name});
	// 		});
	// 	}
	// });
	//
	// form.serviceLines = [];
	// Recognition.serviceLines.forEach((serviceLine) => {
	// 	const currServiceLine = validationService.serviceLines.find(el => el.id === serviceLine.id);
	// 	if (serviceLine.subServiceLines.length === 0) {
	// 		form.serviceLines.push({id: "_" + serviceLine.id, name: currServiceLine.name})
	// 	} else {
	// 		serviceLine.subServiceLines.forEach((subServiceLine) => {
	// 			form.serviceLines.push({id: subServiceLine.id, name: subServiceLine.name})
	// 		});
	// 	}
	// });
	//
	// form.techPractices = [];
	// Recognition.techPractices.forEach((techPractice) => {
	// 	const currTechPractice = validationService.techPractices.find(el => el.id === techPractice.id);
	// 	if (techPractice.subTechPractices.length === 0) {
	// 		form.techPractices.push({id: "_" + techPractice.id, name: currTechPractice.name})
	// 	} else {
	// 		techPractice.subTechPractices.forEach((subTechnology) => {
	// 			form.techPractices.push({id: subTechnology.id, name: subTechnology.name})
	// 		});
	// 	}
	// });
	//
	// form.mainTechPractice = [];
	// const mainTechPractice = Recognition.techPractices.find(el => el.isMain);
	// if(mainTechPractice){
	// 	const mainTechPracticeItem = validationService.techPractices.find(el => el.id === mainTechPractice.id);
	// 	if (mainTechPracticeItem) {
	// 		form.mainTechPractice.push({id: mainTechPracticeItem.id, name: mainTechPracticeItem.name})
	// 	}
	// }
	//
	// form.toolsAndSystems = [];
	// form.certifications = [];
	// Recognition.qualificationAttributes.forEach((attribute) => {
	// 	let currAttribute = validationService.toolsAndSystems.find(el => el.id === attribute.id);
	// 	if (currAttribute){
	// 		form.toolsAndSystems.push({id: attribute.id, name: currAttribute.name})
	// 	}else{
	// 		currAttribute = validationService.certifications.find(el => el.id === attribute.id);
	// 		if(currAttribute){
	// 			form.certifications.push({id: attribute.id, name: currAttribute.name});
	// 		}else{
	// 			console.error("Attribute not found in toolsAndSystems or certifications");
	// 		}
	// 	}
	// });
	//
	// if(Recognition.globalOwners.length === 0){
	// 	form.globalOwners = [{fullName: "", email: ""}];
	// }else{
	// 	form.globalOwners = [...Recognition.globalOwners.map(owner => {return {fullName: owner.fullName, email: owner.email, id: owner.id}})];
	// }
	//
	// if(Recognition.editors.length === 0){
	// 	form.editors = [{editorFullName: "", editorEmail: ""}];
	// }else{
	// 	form.editors = [...Recognition.editors.map(owner => {return {editorFullName: owner.fullName, editorEmail: owner.email, id: owner.id}})];
	// }
	//
	// form.mainClientPersona = Recognition.mainClientPersonas;
	//
	// form.lifecycle = Recognition.lifecycles;
	//
	// form.reference = [...Recognition.references.map(o => {return {referenceDescription: o.description, referenceUrl: o.url}})];
	//
	// form.reference = Recognition.references.map(o => {
	// 	let item = {};
	// 	const id = o.url.split('/').pop();
	// 	item.id = id || "";
	// 	const baseItem = validationService.projects.find(el => el.id == id);
	// 	item.referenceTitle = o.description || "";
	// 	item.firstDatePublished = baseItem?.management?.datePublish || "";
	// 	return item;
	// });
	// if(form.reference.length === 0){
	// 	form.reference.push({id: "", referenceTitle: "", firstDatePublished: ""});
	// }
	//
	// form.relatedRecognitionsEn = [];
	// form.relatedRecognitionsDe = [];
	// form.relatedRecognitionsFr = [];
	// form.relatedRecognitionsIt = [];
	// form.relatedRecognitionsJa = [];
	// form.relatedRecognitionsEs = [];
	// Recognition.relatedRecognitions.forEach(o => {
	// 	const langId = validationService.recognitions.find(el => el.id == o.id)?.translations?.[0]?.languageId
	// 	if(!langId){
	// 		return;
	// 	}
	// 	const lang = LANGUAGE_ARRAY.find(lang => lang.id === langId).lowerCase
	// 	const currRecognition = validationService.recognitions.find(el => el.id == o.id)
	// 	let item = {};
	// 	item.id = o.id + ''
	// 	item.relatedRecognitionsTitle = currRecognition.translations[0].title;
	// 	if(currRecognition.type === RECOGNITION_TYPES_ENUM.GLOBAL){
	// 		item.relatedRecognitionsTitle += ' - Global'
	// 	}else{
	// 		const deliveryCountry = currRecognition.countryRelations.find(el => el.type === countriesEnums.DELIVERY_LOCATION);
	// 		const country = validationService.countries.find(el => el.id === deliveryCountry.countryId);
	// 		item.relatedRecognitionsTitle += ` - for ${country.name}`
	// 	}
	//
	// 	form['relatedRecognitions' + lang[0].toUpperCase() + lang[1]].push(item);
	// })
	//
	// form.type = [RECOGNITION_TYPES.find(el => el.name.toUpperCase() === Recognition.type)];
	//
	// if(Recognition.annualRevenue){
	// 	form.annualRevenue = [validationService.annualRevenues.find(el => el.key === Recognition.annualRevenue)]
	// }else{
	// 	form.annualRevenue = [validationService.annualRevenues.find(el => el.key === "N_A")]
	// }
	//
	// if(Recognition.maturity){
	// 	form.maturity = [validationService.maturities.find(el => el.key === Recognition.maturity)]
	// }else{
	// 	form.maturity = [validationService.maturities.find(el => el.key === "N_A")]
	// }
	//
	// form.globalRecognition = [];
	// if(form.type?.[0].name?.toUpperCase() === RECOGNITION_TYPES_ENUM.LOCALIZED){
	// 	validationService.globalRecognitions.forEach((el) => {
	// 		if(el.id == Recognition.globalRecognitions[0]?.id){
	// 			form.globalRecognition = [el];
	// 		}
	// 	});
	// }
}

export function fillRecognitionWithFormData(Recognition, form, validationService, newQualificationAttributes) {
	//
	// const RecognitionTranslationIndex = 0
	// let languageId = form.language[0]?.id || 1;
	// Recognition.submission.languageId = languageId;
	//
	// Recognition['translations'] = [{languageId: languageId}];
	//
	// Recognition.videoUrl = form.videoLink;
	// Recognition.lifecycles = form.lifecycle; // note the missing S
	// Recognition.competitors = form.competitors.map(competitor => {
	// 	let currComp = {name: competitor.name}
	// 	if (competitor.id) {
	// 		currComp.id = competitor.id;
	// 	}
	// 	return currComp
	// })
	//
	// Recognition.references = [];
	// form.reference.forEach((reference) => {
	// 	if(reference.id === "" || reference.referenceTitle === "" || reference.firstDatePublished === ""){
	// 		return;
	// 	}
	// 	const item = {};
	// 	item.description = reference.referenceTitle;
	// 	let dateFormat = new Date(reference.firstDatePublished);
	// 	item.url = `${window.location.origin}/projects/${dateFormat.getFullYear()}/${dateFormat.getMonth() + 1}/${reference.id}`
	// 	Recognition.references.push(item);
	// })
	//
	// Recognition.relatedRecognitions = [];
	// let allRelatedRecognitions = form.relatedRecognitionsEn.concat(form.relatedRecognitionsDe, form.relatedRecognitionsFr, form.relatedRecognitionsIt, form.relatedRecognitionsJa, form.relatedRecognitionsEs);
	// allRelatedRecognitions.forEach((o) => {
	// 	if(o.id === '' || o.relatedRecognitionsTitle === ''){
	// 		return;
	// 	}
	// 	const item = {};
	// 	item.id = o.id + ''
	// 	Recognition.relatedRecognitions.push(item)
	// })
	//
	// Recognition.globalOwners = [];
	// form.globalOwners.forEach((owner) => {
	// 	if (owner.fullName !== "" && owner.email !== "") {
	// 		let newGlobalOwner = {fullName: owner.fullName, email: owner.email}
	// 		if (owner.id) {
	// 			newGlobalOwner.id = owner.id;
	// 		}
	// 		Recognition.globalOwners.push(newGlobalOwner)
	// 	}
	// });
	//
	// Recognition.editors = [];
	// form.editors.forEach((editor) => {
	// 	if (editor.editorFullName !== "" && editor.editorEmail !== "") {
	// 		let newEditor = {fullName: editor.editorFullName, email: editor.editorEmail}
	// 		if (editor.id) {
	// 			newEditor.id = editor.id;
	// 		}
	// 		Recognition.editors.push(newEditor)
	// 	}
	// });
	//
	// Recognition.mainClientPersonas = form.mainClientPersona; //note the missing S
	//
	// Recognition.countries = [];
	// form.largestMarket.forEach((market) => {
	// 	Recognition.countries.push({id: market.id, type: countriesEnums.LARGEST_MARKETS})
	// });
	// form.fastestGrowingMarket.forEach((market) => {
	// 	Recognition.countries.push({id: market.id, type: countriesEnums.FASTEST_GROWING_MARKETS})
	// });
	// form.deliveryLocation.forEach((location) => {
	// 	if(location){
	// 		Recognition.countries.push({id: location.id, type: countriesEnums.DELIVERY_LOCATION})
	// 	}
	// });
	//
	// Recognition.qualificationAttributes = [];
	// form.toolsAndSystems.forEach((tool) => {
	// 	if (tool.id) {
	// 		Recognition.qualificationAttributes.push({id: tool.id})
	// 	}
	// });
	//
	// form.certifications.forEach((certification) => {
	// 	if (certification.id) {
	// 		Recognition.qualificationAttributes.push({id: certification.id})
	// 	}
	// })
	//
	// if (newQualificationAttributes?.length > 0) {
	// 	newQualificationAttributes.forEach((attribute) => {
	// 		Recognition.qualificationAttributes.push({id: attribute.id})
	// 	});
	// }
	//
	// Recognition.industries = [];
	// if (validationService.industries.length > 0) {
	// 	form?.projectIndustry?.forEach((formIndustry) => {
	// 		let numberId;
	// 		if (typeof formIndustry.id === "string") {
	// 			const currId = formIndustry.id.replace?.('_', "")
	// 			numberId = parseInt(currId)
	// 		} else {
	// 			numberId = formIndustry.id
	// 		}
	// 		validationService.industries.forEach((industry) => {
	// 			if (typeof formIndustry.id === "string") {
	// 				if(numberId === industry.id){
	// 					Recognition.industries.push({id: industry.id, subIndustries: []})
	// 				}
	// 			}else{
	// 				industry.subIndustries.forEach((subIndustry) => {
	// 					if (subIndustry.id === numberId) {
	// 						let industryIndex = Recognition.industries.findIndex(el => el.id === industry.id);
	// 						if (industryIndex !== -1) {
	// 							Recognition.industries[industryIndex].subIndustries.push({id: subIndustry.id})
	// 						} else {
	// 							Recognition.industries.push({id: industry.id, subIndustries: [{id: subIndustry.id}]})
	// 						}
	// 					}
	// 				});
	// 			}
	// 		});
	// 	});
	// }
	//
	// Recognition.serviceLines = [];
	// if (validationService.serviceLines.length > 0) {
	// 	form.serviceLines.forEach((formServiceLine) => {
	// 		let numberId;
	// 		if (typeof formServiceLine.id === "string") {
	// 			const currId = formServiceLine.id.replace?.('_', "")
	// 			numberId = parseInt(currId)
	// 		} else {
	// 			numberId = formServiceLine.id
	// 		}
	// 		validationService.serviceLines.forEach((serviceLine) => {
	// 			if (typeof formServiceLine.id === "string" ) {
	// 				if(numberId === serviceLine.id){
	// 					Recognition.serviceLines.push({id: serviceLine.id, subServiceLines: []})
	// 				}
	// 			}else{
	// 				serviceLine.subServiceLines.forEach((subServiceLine) => {
	// 					if (subServiceLine.id === numberId) {
	// 						let serviceLineIndex = Recognition.serviceLines.findIndex(el => el.id === serviceLine.id);
	// 						if (serviceLineIndex !== -1) {
	// 							Recognition.serviceLines[serviceLineIndex].subServiceLines.push({id: subServiceLine.id})
	// 						} else {
	// 							Recognition.serviceLines.push({id: serviceLine.id, subServiceLines: [{id: subServiceLine.id}]})
	// 						}
	// 					}
	// 				});
	// 			}
	// 		});
	// 	});
	// }
	//
	// Recognition.techPractices = [];
	// if (validationService.techPractices.length > 0) {
	// 	form.techPractices.forEach((formTechPractice) => {
	// 		let numberId;
	// 		if (typeof formTechPractice.id === "string") {
	// 			const currId = formTechPractice.id.replace?.('_', "")
	// 			numberId = parseInt(currId)
	// 		} else {
	// 			numberId = formTechPractice.id
	// 		}
	//
	// 		validationService.techPractices.forEach((techPractice) => {
	// 			if (typeof formTechPractice.id === "string") {
	// 				if(numberId === techPractice.id){
	// 					Recognition.techPractices.push({id: techPractice.id, subTechPractices: []})
	// 				}
	// 			}else{
	// 				techPractice.subTechPractices.forEach((subTechnology) => {
	// 					if (subTechnology.id === numberId) {
	// 						let techPracticeIndex = Recognition.techPractices.findIndex(el => el.id === techPractice.id);
	// 						if (techPracticeIndex !== -1) {
	// 							Recognition.techPractices[techPracticeIndex].subTechPractices.push({id: subTechnology.id})
	// 						} else {
	// 							Recognition.techPractices.push({id: techPractice.id, subTechPractices: [{id: subTechnology.id}]})
	// 						}
	// 					}
	// 				});
	// 			}
	// 		});
	// 	});
	// }
	//
	// if (form.mainTechPractice.length > 0) {
	// 	const techPracticeId = form.mainTechPractice[0].id;
	// 	Recognition.techPractices.find(el => el.id === techPracticeId).isMain = true;
	// }
	//
	// Recognition.type = RECOGNITION_TYPES.find(el => el.id === form.type[0]?.id)?.name || null;
	//
	// Recognition.annualRevenue = validationService.annualRevenues.find(el => el.id === form.annualRevenue[0]?.id)?.key || null;
	//
	// Recognition.maturity = validationService.maturities.find(el => el.id === form.maturity[0]?.id)?.key || null;
	//
	// if(form.type?.[0]?.name?.toUpperCase() === RECOGNITION_TYPES_ENUM.LOCALIZED && form.globalRecognition?.[0]?.id){
	// 	Recognition.globalRecognitions = [{id: form.globalRecognition?.[0]?.id}];
	// }else{
	// 	Recognition.globalRecognitions = [];
	// }
	// Recognition['translations'][RecognitionTranslationIndex].title = form.title;
	// Recognition['translations'][RecognitionTranslationIndex].description = form.description;
	// Recognition['translations'][RecognitionTranslationIndex].biggestMarketConclusion = form.biggestMarketConclusion;
	// Recognition['translations'][RecognitionTranslationIndex].keyMarketDrivers = form.keyMarketDrivers;
	// Recognition['translations'][RecognitionTranslationIndex].marketOpportunities = form.marketOpportunities;
	// Recognition['translations'][RecognitionTranslationIndex].keyHighlights = form.keyHighlights;
	// Recognition['translations'][RecognitionTranslationIndex].additionalNotes = form.additionalNotes;
	// Recognition['translations'][RecognitionTranslationIndex].clientNeeds = form.clientNeeds;
	// Recognition['translations'][RecognitionTranslationIndex].clientBenefits = form.clientBenefits;
	// Recognition['translations'][RecognitionTranslationIndex].tips = form.tips;
	// Recognition['translations'][RecognitionTranslationIndex].Recognition = {id: Recognition.id};
}

export function addNewQualificationAttributes(qualificationAttributes) {
	return axios.post(`${endpoint}/qualification-attributes`, qualificationAttributes);
}

export function createRecognition(Recognition) {
	return axios.post(`${endpoint}/recognitions`, Recognition, {
		headers: {
			'Content-Type': `multipart/form-data`,
		}
	});
}

export function saveRecognition(Recognition) {
	return axios.patch(`${endpoint}/recognitions/save`, Recognition);
}

export function saveRecognitionWithValidations(Recognition) {
	return axios.patch(`${endpoint}/recognitions/update`, Recognition);
}

export function createSnapshot(snapshot, type) {
	const body = {"snapshot": JSON.stringify(snapshot)}

	if (type === "Recognition") {
		body.Recognition = {'id': snapshot.id}
	} else {
		body.sector = {'id': snapshot.id}
	}

	return axios.post(`${URL}/gop/snapshots`, body);
}

export function saveThumbnail(RecognitionId, thumbnail) {
	return axios.put(`${endpoint}/recognitions/files/images/upload?RecognitionId=${RecognitionId}&gopImageType=THUMBNAIL`, thumbnail, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function getThumbnail(RecognitionId) {
	return axios.get(`${endpoint}/recognitions/files/images/get-by-Recognition-id-and-image-type?RecognitionId=${RecognitionId}&imageType=THUMBNAIL`);
}

export function deleteThumbnail(RecognitionId) {
	return axios.delete(`${endpoint}/recognitions/files/images/delete?RecognitionId=${RecognitionId}&imageType=THUMBNAIL`);
}

//================================================================================================

export function getPanoramicPhoto(RecognitionId) {
	return axios.get(`${endpoint}/recognitions/files/images/get-by-Recognition-id-and-image-type?RecognitionId=${RecognitionId}&imageType=PANORAMIC`);
}

export function savePanoramicPhoto(RecognitionId, panoramicPhoto) {
	return axios.put(`${endpoint}/recognitions/files/images/upload?RecognitionId=${RecognitionId}&gopImageType=PANORAMIC`, panoramicPhoto, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function deletePanoramicPhoto(RecognitionId) {
	return axios.delete(`${endpoint}/recognitions/files/images/delete?RecognitionId=${RecognitionId}&imageType=PANORAMIC`);
}

//================================================================================================
export function getMobilePanoramicPhoto(RecognitionId) {
	return axios.get(`${endpoint}/recognitions/files/images/get-by-Recognition-id-and-image-type?RecognitionId=${RecognitionId}&imageType=MOBILE_PANORAMIC`);
}

export function saveMobilePanoramicPhoto(RecognitionId, mobilePanoramicPhoto) {
	return axios.put(`${endpoint}/recognitions/files/images/upload?RecognitionId=${RecognitionId}&gopImageType=MOBILE_PANORAMIC`, mobilePanoramicPhoto, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function deleteMobilePanoramicPhoto(RecognitionId) {
	return axios.delete(`${endpoint}/recognitions/files/images/delete?RecognitionId=${RecognitionId}&imageType=MOBILE_PANORAMIC`);
}
//================================================================================================
export function uploadFile(RecognitionId, fileToUpload) {
	return axios.put(`${endpoint}/recognitions/files/upload?RecognitionId=${RecognitionId}`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data`,
		}
	});
}

export function getResources(RecognitionId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllAdditionalResourcesByRecognitionId(RecognitionId: ${RecognitionId}) {
        		id
						name
						url
						awsKey
					}
   			 }`
		}
	})
		.then(response => {
			return response.data.data.getAllAdditionalResourcesByRecognitionId
		});

}

export function getRecognitions(RecognitionId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllRecognitionRecognitionsByRecognitionId(RecognitionId: ${RecognitionId}) {
        		id
						name
						url
						awsKey
						logoUrl
    				logoAwsKey
					}
   			 }`
		}
	})
		.then(response => {
			return response.data.data.getAllRecognitionRecognitionsByRecognitionId
		});

}

export function uploadResource(RecognitionId, fileToUpload) {
	return axios.post(`${endpoint}/recognitions/${RecognitionId}/additional-resources`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data;boundary=12345;`,
		}
	});
}

export function uploadRecognition(RecognitionId, fileToUpload) {
	return axios.post(`${endpoint}/recognitions/${RecognitionId}/recognitions`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data;boundary=12345;`,
		}
	});
}

export function deleteResource(RecognitionId, resourceId) {
	return axios.delete(`${endpoint}/recognitions/${RecognitionId}/additional-resources/${resourceId}`);
}

export function deleteRecognition(RecognitionId, resourceId) {
	return axios.delete(`${endpoint}/recognitions/${RecognitionId}/recognitions/${resourceId}`);
}

export function deleteFile(RecognitionId, fileName) {
	return axios.delete(`${endpoint}/recognitions/files/delete?RecognitionId=${RecognitionId}&fileName=${fileName}`);
}

export function getFiles(RecognitionId) {
	return axios.get(`${endpoint}/recognitions/files/${RecognitionId}`).then(response => {
		return response.data;
	})
}

//================================================================================================

export function publishRecognition(id) {
	return axios.post(`${endpoint}/recognitions/${id}/publish`).then(response => {
		return response.data;
	})
}

export function publishSectorPresentation(id) {
	return axios.post(`${endpoint}/sector-presentations/${id}/publish`).then(response => {
		return response.data;
	})
}

export function getUnpublishedRecognitionById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getUnpublishedRecognitionById(RecognitionId: ${id}) {
						id,
						isActive,
						isPublished,
						creatorId,
						videoUrl,
						type,
						annualRevenue,
						maturity,
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedRecognitions{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedRecognitions{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalRecognitions{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
							biggestMarketConclusion,
							keyMarketDrivers,
							marketOpportunities,
							keyHighlights,
							additionalNotes,
							clientNeeds,
							clientBenefits,
							tips
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							isMain,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						},
						competitors {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getUnpublishedRecognitionById
		});
}

export function getPublishedRecognitionById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getPublishedRecognitionById(RecognitionId: ${id}) {
						id,
						isActive,
						isPublished,
						creatorId,
						videoUrl,
						annualRevenue,
						maturity,
						userFavorites {
							userId
						},
						additionalResources{
							id,
							url,
							name
						},
						recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
						relatedRecognitions{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						type,
						localizedRecognitions{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalRecognitions{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
							biggestMarketConclusion,
							keyMarketDrivers,
							marketOpportunities,
							keyHighlights,
							additionalNotes,
							clientNeeds,
							clientBenefits,
							tips
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							isMain,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						},
						competitors {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedRecognitionById
		});
}

export function deleteRecognitionById(recognitionId) {
	return axios.delete(`${endpoint}/recognitions/${recognitionId}/delete`)
		.then(response => {
			return response.data;
		})
}

export function deleteSectorPresentationById(sectorId) {
	return axios.delete(`${endpoint}/sector-presentations/${sectorId}/delete`)
		.then(response => {
			return response.data;
		})
}

export function archiveRecognitionById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation ArchiveRecognition {
					archiveRecognition(RecognitionId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.archiveRecognition
		});
}

export function unArchiveRecognitionById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation UnArchiveRecognition {
					unArchiveRecognition(RecognitionId: ${id}) {
						id,
						isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.unArchiveRecognition
		});
}

export function archiveSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation ArchiveSector {
					archiveSector(sectorId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.archiveSector
		});
}

export function unArchiveSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation UnArchiveSector {
					unArchiveSector(sectorId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.unArchiveSector
		});
}

export function addToRecognitionFavorites(recognitionId, userId) {
	return axios.post(`${endpoint}/recognitions/${recognitionId}/add-favorite?userId=${userId}`);
}

export function removeFromRecognitionFavorites(recognitionId, userId) {
	return axios.post(`${endpoint}/recognitions/${recognitionId}/remove-favorite?userId=${userId}`);
}

export function addToSectorFavorites(sectorId, userId) {
	return axios.post(`${endpoint}/sector-presentations/${sectorId}/add-favorite?userId=${userId}`);
}

export function removeFromSectorFavorites(sectorId, userId) {
	return axios.post(`${endpoint}/sector-presentations/${sectorId}/remove-favorite?userId=${userId}`);
}

export function getUrlParams() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const params = {};

	for (const [name, value] of urlParams) {
		params[name] = value;
	}

	return params;
}

export function getRecognitionsIdsByFilterCriteria(criteria, text) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if(criteria.excludeIds){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}excludedIds:[${criteria.excludeIds.join(',')}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	if (text) {
		criteriaString = criteriaString.replace("}", `,text:"${text}"}`);
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					globalRecognitions{
						id
					}
				}
			}`
		}
	});
}

export function getRelatedRecognitionsByFilterCriteria(criteria, text) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace("}", `,text:"${text}"}`);
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					translations {
            languageId
            title
        	}
				}
			}`
		}
	});
}

export function getRecognitionDataStatistics(criteria, text){
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"1999-01-01", to:"2099-12-31"}}`);
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${9999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					statistics {
						id,
						action,
						date,
					}
					views,
					translations {
						title,
						languageId
					}
				}
			}`
		}
		});
}

export function getRecognitionsReportDataWithCriteria(criteria, text, dateFrom, dateTo) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	if(dateFrom && dateTo){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"${dateFrom}", to:"${dateTo}"}}`);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${99999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					creatorId,
					videoUrl,
					userFavorites {
						userId
					},
					isActive,
					isPublished,
					type,
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					},
					references {
						id,
						description,
						url
					},
					recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
					industryRelations {
						id,
						industryId,
						subIndustryRelations {
							id,
							subIndustryId
						}
					},
					translations {
						id,
						languageId,
						title,
						description,
					},
					countryRelations {
						id,
						countryId,
						type
					},
					serviceLineRelations {
						id,
						serviceLineId,
						subServiceLineRelations {
							id,
							subServiceLineId
						}
					},
					techPracticeRelations {
						id,
						techPracticeId,
						isMain,
						subTechPracticeRelations {
							id,
							subTechPracticeId
						}
					},
					qualificationAttributeRelations {
						id,
						qualificationAttributeId
					},
					globalOwners {
						id,
						fullName,
						email
					},
					editors{
						id,
						fullName,
						email
					},
					mainClientPersonas {
						id,
						jobDescription
					},
					lifecycles {
						id,
						name
					},
					competitors {
						id,
						name
					},
					statistics {
						action
					}
				}
			}`
		}
	});
}

export function getRecognitionsByFilterCriteria(criteria, text, page, pageSize, order) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:{order:"${order}", by:"id"}}`);
	}
	if(criteria.excludeIds){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}excludedIds:[${criteria.excludeIds.join(',')}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					isActive,
					isPublished,
					type,
					userFavorites {
						userId
					},
					editors{
						id,
						fullName,
						email
					},
					countryRelations{
						countryId,
						type
					},
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					}
					images {
						url,
						type
					},
					translations {
						languageId,
						title,
						description
					},
					files {
						url,
						type
					},
					techPracticeRelations {
						techPracticeId,
						isMain,
						subTechPracticeRelations {
							subTechPracticeId
						}
					}
				}
			}`
		}
	});
}

export function getGlobalSearchRecognitionsByCriteria(criteria, text, page, pageSize, order) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:{order:"${order}"}}`);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchRecognitionByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					type,
					translations {
						languageId,
						title,
						description,
						tips,
						biggestMarketConclusion,
						keyMarketDrivers,
						marketOpportunities,
						keyHighlights,
						additionalNotes,
						clientNeeds,
						clientBenefits
					}
				}
			}`
		}
	});
}

export function getSectorDataStatistics(criteria, text){
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"1999-01-01", to:"2099-12-31"}}`);
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${9999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchSectorByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					statistics {
						id,
						action,
						date,
					}
					views,
					translations {
						title,
						languageId
					}
				}
			}`
		}
	});
}
export function getSectorsByFilterCriteria(criteria, text, page, pageSize, order) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:[{order:"${order}", by:"id"}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', RECOGNITION_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', RECOGNITION_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', RECOGNITION_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchSectorByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					isActive,
					isPublished,
					category,
					type,
					userFavorites {
						userId
					},
					editors{
						id,
						fullName,
						email
					},
					recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
					countryRelations{
						countryId,
						type
					},
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					}
					images {
						url,
						type
					},
					translations {
						languageId,
						title,
						description
					},
					files {
						url,
						type
					},
					industryRelations {
						industryId,
						isMain
					}
				}
			}`
		}
	});
}

export function fetchLatestPublishedRecognitions(recognitionsNumber) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getLatestPublishedRecognitions(numberOfRecognitions: ${recognitionsNumber}) {
							id,
							images {
									id,
									 url,
									type
							},
							type,
							countryRelations{
								countryId,
            		type
							},
							translations {
									id,
									languageId,
									title
							},
							submission {
									publishedDateTime,
									languageId
							}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getLatestPublishedRecognitions
		});
}

export function getPublishedSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getPublishedSectorById(sectorId: ${id}) {
						id,
						isActive,
						category,
						creatorId,
						isPublished,
						videoUrl,
						type,
						relatedOffers {
							images {
								id
								url
								key
								type
							}
							id
							type
							isActive
							isPublished
							translations {
								id
								languageId
								title
								description
							}
						}
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedSectors{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							isMain,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedSectorById
		});
}

export function getUnpublishedSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getUnpublishedSectorById(sectorId: ${id}) {
						id,
						isActive,
						isPublished,
						category,
						creatorId,
						videoUrl,
						type,
						relatedOffers {
							images {
								id
								url
								key
								type
							}
							id
							type
							isActive
							isPublished
							translations {
								id
								languageId
								title
								description
							}
						}
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive,
							isPublished,
							translations {
								languageId
								title
								description
								insights
							},
							images {
								id,
								type,
								url
							}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedSectors{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							isMain,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getUnpublishedSectorById
		});
}

export function getRecognitionsList() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchPaginatedRecognitions(
							criteria: {
									sort: { by: "lastUpdateDate", order: "DESC" }
									pageable: { page: 0, size: 1000 }
							}
					) {
							totalElements
							totalPages
							size
							number
							content {
									id
									isActive
									isPublished
									translations {
											languageId
											title
									}
									images {
											type
											url
									}
									userFavorites {
											userId
											id
									}
							}
					}
				}
			`
		}
	}).then(response => {
		return response.data.data.searchPaginatedRecognitions.content
	})
}

// export function getRecognitionsList() {
// 	return axios({
// 		url: GRAPHQL_ENDPOINT,
// 		method: METHOD_TYPE.POST,
// 		data: {
// 			query: `{
// 				searchRecognitions(
// 					criteriaFilter: {isManagement: false, contentLanguageId: 1, types: [], pageable: {page: 0, size: 10000}}
// 					) {
// 							id
// 							translations {
// 								id
// 								languageId
// 								title
// 							}
// 							url
// 							isPublished
// 							isActive
// 							file {
// 								id
// 								url
// 								key
// 							}
// 							images {
// 								id
// 								type
// 								url
// 								key
// 							}
// 					}
// 				}
// 			`
// 		}
// 	}).then(response => {
// 		return response.data.data.searchRecognitions
// 	})
// }

export function getRecognitionsDropdownList() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchPaginatedRecognitions(
							criteria: {
									sort: { by: "lastUpdateDate", order: "DESC" }
									pageable: { page: 0, size: 1000 }
							}
					) {
							totalElements
							totalPages
							size
							number
							content {
									id
									isActive
									isPublished
									translations {
											languageId
											title
									}
							}
					}
			}
			`
		}
	}).then(response => {
		return response.data.data.searchPaginatedRecognitions?.content
	})
}

export function deleteNewRecognitionById(id){
	return axios.delete(`${endpoint}/recognitions/${id}/delete`);
}
